 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"AddArticle~SingleArticle":"AddArticle~SingleArticle","AddArticle":"AddArticle","SingleArticle":"SingleArticle","Article":"Article","CryptoCurrency":"CryptoCurrency","GenreListMovie":"GenreListMovie","GenreListTV":"GenreListTV","Home":"Home","Login":"Login","Profile":"Profile","Register":"Register","Search":"Search","SingleEpisode":"SingleEpisode","SingleMovie":"SingleMovie","SinglePerson":"SinglePerson","SingleSeason":"SingleSeason","SingleTv":"SingleTv","notFound":"notFound"}[chunkId]||chunkId) + "." + {"AddArticle~SingleArticle":"0c4c0491","AddArticle":"441d242a","SingleArticle":"6d18ef2a","Article":"abd8b29f","CryptoCurrency":"0a187264","GenreListMovie":"cc1b3662","GenreListTV":"563de8f6","Home":"9ebb8109","Login":"875518a8","Profile":"94944b03","Register":"95f66db8","Search":"1c4ba047","SingleEpisode":"fe3f72bd","SingleMovie":"e23ee93a","SinglePerson":"200209a4","SingleSeason":"626cd9c7","SingleTv":"3dd119d7","chunk-2d0a4d2f":"384f1065","chunk-5ac69ace":"b6fb198f","chunk-7315e91e":"464a3434","notFound":"43bc3293","chunk-180b2e82":"1dd50c5c","chunk-30102410":"fcfed272","chunk-426b643e":"19ef2b63","chunk-3caffd54":"cf687ae6","chunk-04795cdd":"61d248b4","chunk-0dd94525":"27eb1bad","chunk-5f629487":"24a16921","chunk-742d3aca":"1d4f99c7","chunk-048caa36":"59f01395","chunk-0b7c339f":"8b09ba8d","chunk-12150127":"e4eb6033","chunk-43600dae":"b5408e17","chunk-2d0bd1ac":"6ac26651","chunk-2d0dad0e":"d64a3b67","chunk-7d771205":"bc5d2d57","chunk-1915abf8":"4fd6b411","chunk-50d88bb3":"8728c38e","chunk-6ea3c909":"cb2b99a7","chunk-0f16e7b5":"aa99779d","chunk-4a48e9b7":"eb0d0e75"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"Article":1,"CryptoCurrency":1,"Home":1,"Login":1,"Profile":1,"Register":1,"chunk-5ac69ace":1,"chunk-04795cdd":1,"chunk-5f629487":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"AddArticle~SingleArticle":"AddArticle~SingleArticle","AddArticle":"AddArticle","SingleArticle":"SingleArticle","Article":"Article","CryptoCurrency":"CryptoCurrency","GenreListMovie":"GenreListMovie","GenreListTV":"GenreListTV","Home":"Home","Login":"Login","Profile":"Profile","Register":"Register","Search":"Search","SingleEpisode":"SingleEpisode","SingleMovie":"SingleMovie","SinglePerson":"SinglePerson","SingleSeason":"SingleSeason","SingleTv":"SingleTv","notFound":"notFound"}[chunkId]||chunkId) + "." + {"AddArticle~SingleArticle":"31d6cfe0","AddArticle":"31d6cfe0","SingleArticle":"31d6cfe0","Article":"53b9ad1a","CryptoCurrency":"84afe2fa","GenreListMovie":"31d6cfe0","GenreListTV":"31d6cfe0","Home":"81815548","Login":"1fa5a8bf","Profile":"b84fe588","Register":"249959e0","Search":"31d6cfe0","SingleEpisode":"31d6cfe0","SingleMovie":"31d6cfe0","SinglePerson":"31d6cfe0","SingleSeason":"31d6cfe0","SingleTv":"31d6cfe0","chunk-2d0a4d2f":"31d6cfe0","chunk-5ac69ace":"1cbb875b","chunk-7315e91e":"31d6cfe0","notFound":"31d6cfe0","chunk-180b2e82":"31d6cfe0","chunk-30102410":"31d6cfe0","chunk-426b643e":"31d6cfe0","chunk-3caffd54":"31d6cfe0","chunk-04795cdd":"dfba06a8","chunk-0dd94525":"31d6cfe0","chunk-5f629487":"dfba06a8","chunk-742d3aca":"31d6cfe0","chunk-048caa36":"31d6cfe0","chunk-0b7c339f":"31d6cfe0","chunk-12150127":"31d6cfe0","chunk-43600dae":"31d6cfe0","chunk-2d0bd1ac":"31d6cfe0","chunk-2d0dad0e":"31d6cfe0","chunk-7d771205":"31d6cfe0","chunk-1915abf8":"31d6cfe0","chunk-50d88bb3":"31d6cfe0","chunk-6ea3c909":"31d6cfe0","chunk-0f16e7b5":"31d6cfe0","chunk-4a48e9b7":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
